import { Cart, Product, Variant } from '../shop';

const AddToCart = (product: Product, variant: Variant) => {
  const lastCollection = product.collections?.[product.collections?.length - 1];

  if ((<any>window).fbq) {
    (<any>window).fbq('track', 'AddToCart', {
      content_name: variant.title.replace(/["']/g, ''),
      content_category: lastCollection.title,
      content_ids: [variant.id.split('/').pop()],
      value: variant.price?.amount,
      currency: variant.price?.currencyCode,
    });
  }
};

const InitiateCheckout = (cart: Cart) => {
  const variantIds = cart.lines.map(a => a.merchandise.id.split('/').pop());

  if ((<any>window).fbq) {
    (<any>window).fbq('track', 'InitiateCheckout', {
      content_ids: [...variantIds],
      value: cart.cost.totalAmount.amount,
      currency: cart.cost.totalAmount.currencyCode,
    });
  }
};

const ViewContent = (product: Product, variant?: Variant) => {
  const lastCollection = product?.collections?.[product.collections?.length - 1];
  const price = variant?.price || product.priceRange.minVariantPrice;

  var name = [product.title, variant?.title].filter(a => a).join(' - ');

  if ((<any>window).fbq) {
    (<any>window).fbq('track', 'ViewContent', {
      content_type: 'product',
      content_name: name.replace(/["']/g, ''),
      content_category: lastCollection.title,
      content_ids: [(variant || product).id.split('/').pop()],
      value: price.amount,
      currency: price.currencyCode,
    });
  }
};

const PageView = () => {
  if ((<any>window).fbq) {
    (<any>window).fbq('track', 'PageView ');
  }
};

export const MetaPixel = {
  AddToCart,
  ViewContent,
  InitiateCheckout,
  PageView,
};

async function hashSha256(string: string) {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(bytes => bytes.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

async function hashSha1(string: string) {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await crypto.subtle.digest('SHA-1', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(bytes => bytes.toString(16).padStart(2, '0')).join('');
  return hashHex;
}
